export default __webpack_public_path__ + "static/xray-2f0a1bafe836a0fd58f0ef4a602bbf03.jpg";